// extracted by mini-css-extract-plugin
export default {"container":"QuizToastContainer-module__container__NTRnI","toast":"QuizToastContainer-module__toast__GO6Hs"};